import {useState, useEffect,useMemo} from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';

const SelectGruposUser = ({id, value, onChange, isInvalid, isClearable}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const user = useSelector((state) => state.auth.currentUser);
    useEffect(() => {
        if(user && user?.grupos?.length > 0){
            setItems(user?.grupos)
        }else{
            setItems([])
        }
    }, [user])

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if(items?.length > 0){
            const newOptions = items.map((item) => {
                return {
                    value: item.id_g,
                    label: item.nombre_g
                };
            })
            setOptions(newOptions);
        }
    }, [items])
    useEffect(() => {
        if(typeof value === 'string' || typeof value === 'number'){
            setSelectedValue(
                options?.find((opt) => opt.value === Number(value))
            );
        } else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = items.find(it=>it.id_g === va);
                if(item){
                    return {
                        value:item.id_g,
                        label:item.nombre_g,
                    };
                }
                return null
            }))
        }else{
            setSelectedValue(null)
        }
    }, [value])

    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectGruposUser.defaultProps = {
    isClearable: false
};

export default SelectGruposUser;
